export const mutations = {
  setLogs(state, payload) {
    state.logs = payload
  },
  setLog(state, payload) {
    state.log = payload
  },
  setLogFiltros(state, payload) {
    state.filters = payload
  }
};

export default {};
